import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9a025568"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-view" }
const _hoisted_2 = { class: "account-view__header" }
const _hoisted_3 = { class: "account-view__header-photo" }
const _hoisted_4 = { class: "account-view__header-name" }
const _hoisted_5 = { class: "account-view__header-account-type" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon el-icon-arrow--right-grey-big account-view__menu-go-icon" }, null, -1))
const _hoisted_7 = { class: "account-view__container" }
const _hoisted_8 = { class: "account-view__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxAvatar = _resolveComponent("PxAvatar")!
  const _component_PxTabBar = _resolveComponent("PxTabBar")!
  const _component_VDivider = _resolveComponent("VDivider")!
  const _component_VListItemTitle = _resolveComponent("VListItemTitle")!
  const _component_VListItemAction = _resolveComponent("VListItemAction")!
  const _component_VListItem = _resolveComponent("VListItem")!
  const _component_VList = _resolveComponent("VList")!
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_PxBottomBar = _resolveComponent("PxBottomBar")!
  const _component_AccountSettingsModal = _resolveComponent("AccountSettingsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PxTabBar, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_PxAvatar, {
              loading: !_ctx.company,
              name: _ctx.companyName,
              photo: _ctx.companyLogo,
              size: 74
            }, null, 8, ["loading", "name", "photo"])
          ]),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.companyName), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$profile.userType()), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_VList, { class: "account-view__menu" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (item.divider)
              ? (_openBlock(), _createBlock(_component_VDivider, {
                  key: index,
                  inset: item.inset,
                  class: "account-view__menu-divider"
                }, null, 8, ["inset"]))
              : (item.visible)
                ? (_openBlock(), _createBlock(_component_VListItem, {
                    key: item.key,
                    class: _normalizeClass([[{ 'is-dark': item.dark }, `menu__tile--${item.key}`], "account-view__menu-tile"]),
                    avatar: "",
                    onClick: ($event: any) => (_ctx.onItemClick(item))
                  }, _createSlots({
                    default: _withCtx(() => [
                      _createVNode(_component_VListItemTitle, {
                        class: "account-view__menu-title",
                        textContent: _toDisplayString(item.title)
                      }, null, 8, ["textContent"]),
                      _createVNode(_component_VListItemAction, null, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, [
                    (item.icon)
                      ? {
                          name: "prepend",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass([`el-icon-${item.icon}`, "icon account-view__menu-icon"])
                            }, null, 2)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["class", "onClick"]))
                : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_PxButton, {
        class: "el-button--block logout-btn",
        size: "large",
        type: "blue-grey",
        onClick: _ctx.onClickLogout
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("common.logout")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("common.footer.copyright", {
            year: _ctx.currentYear,
          })), 1)
    ]),
    _createVNode(_component_PxBottomBar, { items: _ctx.mobileMenuItems }, null, 8, ["items"]),
    _createVNode(_component_AccountSettingsModal, {
      visibility: _ctx.isAccountSettingsVisible,
      "onUpdate:visibility": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isAccountSettingsVisible) = $event)),
      "open-view": _ctx.accountSettingsView
    }, null, 8, ["visibility", "open-view"])
  ]))
}